import React from "react";
import {
	Row,
	Col,
} from "reactstrap";
import { TabPane } from "reactstrap";
import Image from "components/Image";

const caseInfo =
{
	source: "Shengwei Zhu",
	source2: "Lingzhe Wang",
};

export default function IndoorPresenter() {
	return (
		<TabPane tabId={"musicians"}>
			<Row style={{ padding: 16 }}>
				<Col xs="12" sm={{ size: 12 }}>
					<h4>Musician Playing Instrument</h4>
					<p>
						In this case, a musician was assumed to play a clarinet at the
						center of the room with both the supply and exhaust at the ceiling
						level, which is the typical ventilation system design in the U.S.
						<strong>The room has an air exchange rate of 3 ACH.</strong> The air
						speed at the end of the clarinet was 0.26 m/s, according to
						measurements conducted at UC Boulder, which is slower than the
						airflow produced by typical exhalation. As a result, the spread of
						viral aerosols from the clarinet was dominated by indoor ventilation
						flow soon after they enter the room, the aerosols were spread
						throughout the room. Some{" "}
						<strong>viral aerosols can stay indoors up to 41 minutes</strong>,
						resulting in a long exposure duration.
					</p>
				</Col>
				<Col xs="12" sm={{ size: 10, offset: 1 }}>
					<Row>
						<Col xs={12} sm={6}>
							<h5 className="text-center">Case 1: Clarinet</h5>
							<figure className="figure">
								<Image src={`images/covid/indoor/clarine-con.gif`} alt="" />
								<figcaption className="figure-caption">
									Animation of of airborn viral concentraion due to musician in
									indoor space. Animation duraction 60 minutes.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
					</Row>
				</Col>
				<Col xs='12' sm={{size: 12}}>
					<h4> Aerosol Generation from a Singer </h4>
					<p>
						The risk of COVID-19 infection from droplets and aerosols generated
						from playing band instruments and singing could be significant.
						This study was conducted to better understand potential risk and how
						to mitigate the risk so that musicians can return to play,
						and music students can continue practicing,
						performing, and playing in school bands. The project involved
						Aerosol Measurement to measure particle
						generation, dispersion, and Flow Visualization
						(PIV and Schlieren Image) to qualitatively
						document emission and particulate plumes.
					</p>
				</Col>
				<Col xs='12' sm={{size: 10, offset: 1}}>
					<p> <br></br> </p>
					<Row>
					<Col xs={12} sm={6}>
						<h5 className="text-center">Experiment Setting 1</h5>
						<figure className='figure'>
							<Image src={'images/covid/Musicians/ExperimentSetting1.png'} alt=''/>
						<figcaption className="figure-caption">
							This experiment measured the particle removal of a face mask.
						</figcaption>
						<figcaption className="figure-caption">
							Source: City@UMD [{caseInfo.source2}]
						</figcaption>
						</figure>
						<p>
							In experiment one, the singer sung into a funnel as to prevent entrainment of
							ambient air. The particle concentration near the mouth is
							measured by the TSI 3321 (APS: Aerodynamic Particle Sizer).
						</p>
					</Col>
					<Col xs={12} sm={6}>
						<h5 className="text-center">Experiment Setting 2</h5>
						<figure className='figure'>
							<Image src={'images/covid/Musicians/ExperimentSetting2.png'} alt=''/>
						<figcaption className="figure-caption">
							This experiment measured the particle removal of a fan filter system.
						</figcaption>
						<figcaption className="figure-caption">
							Source: City@UMD [{caseInfo.source2}]
						</figcaption>
						</figure>
						<p>
							In experiment two, the localized air cleaning consisted of two 20"
							(0.508 m) by 20" (0.508 m) box fans with attached (duct tapped)
							MERV-13 filters. The distance between these two fans was 30" (0.762 m).
							The singer sat in the middle of the two fans and sang in the forwards direction.
							The particle concentrations were measured at two locations, one close to the
							mouth by TSI 9306 (Optical particle counter), and another at the end
							of the air passage between the two fans by TSI 3321.
						</p>
					</Col>
					</Row>
				</Col>

				<Col xs='12' sm={{size: 10, offset: 1}}>
					<p> <br></br></p>
					<h4 className="text-center">Particle Imaging Velocimetry (PIV)</h4>
					<p> <br></br> </p>
					<Row>
						<Col xs={12} sm={6}>
							<figure className="figure">
								<Image src={'images/covid/Musicians/PIV.png'} alt=''/>
							<figcaption className="figure-caption">
								Source: City@UMD [{caseInfo.source2}]
							</figcaption>
							</figure>
						</Col>
						<Col xs={12} sm={6}>
							<p>
							The Particle Imaging Velocimetry (PIV) used a laser to measure the
							speed of the exhaled particles. Laser light sheets were placed
							perpendicular to the principal flows. Any emitted droplets were
							lit up when they passed through the laser sheet and these images
							were recorded by a high-speed camera. These recordings were then
							used to calculate the velocity of the flow. The singer was
							spatially separated from the small chamber by a protection shield,
							and sang into the chamber through a small hole at the height
							of the singer's mouth. The singer also wore a pair of laser safety glasses during
							the experiment.
							</p>
							<h5 className="text-center">Flow Field Image</h5>
							<figure className="figure">
								<Image src={'images/covid/Flowfield.png'} alt=''/>
								<figcaption className="figure-caption">
									This is an image of the Flow Field from the PIV.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source2}]
								</figcaption>
							</figure>
						</Col>
					</Row>
					<Row>
						<Col xs={12} sm={6}>
							<h5 className="text-center">Schlieren Imaging</h5>
							<figure className="figure" className="text-center">
								<Image src={'images/covid/Musicians/SchlierenImage.png'} alt=''/>
							<figcaption className="figure-caption">
								Source: City@UMD [{caseInfo.source2}]
							</figcaption>
								<p>
									The Schlieren image was used to see the flow pattern from the instruments or the singers.
									This experiment was recorded by a scientific CMOS camera with a CCD-resolution of 2560 × 2160 pixel at 50 Hz.
									The flow pattern was calculated according to the temperature difference between exhaled airflow and ambient air.
									The singer stood between the camera and the target at the location shown in the picture.
								</p>
								</figure>
						</Col>
						<Col>
							<h5 className="text-center">PIV Result</h5>
							<figure className='figure'>
							<Image src='images/covid/Musicians/BOSWithSound.gif' alt=''/>
								<figcaption className='figure-caption'>
									Aerosol flow pattern from the singer captured by the PIV.
									The duration of this video is 45 seconds.
								</figcaption>
								<figcaption className="figure-caption">
								Source: City@UMD [{caseInfo.source2}]
								</figcaption>
							</figure>
						</Col>
					</Row>
				</Col>
			</Row>
		</TabPane>
	);
}
